import { MetadataWrapper } from './ChannelListItem.styles';

const MetadataInfo = () => {
  return (
    <MetadataWrapper>{/* TODO: add metadata info later */}</MetadataWrapper>
  );
};

export default MetadataInfo;
